import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CabinTypes, ICabinTypesRedux } from '../../../../../interfaces/src/lib/interfaces/index';

const initialState: ICabinTypesRedux = {
  cabinTypes: null,
  secondCabinTypes: null,
};

const cabinTypesSlice = createSlice({
  name: 'cabinTypes',
  initialState,
  reducers: {
    setCabinTypes: (state: ICabinTypesRedux, action: PayloadAction<CabinTypes[]>) => {
      state.cabinTypes = action.payload;
    },
    setSecondCabinTypes: (state: ICabinTypesRedux, action: PayloadAction<CabinTypes[]>) => {
      state.secondCabinTypes = action.payload;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase('resetFromPriceType', () => {
        return initialState;
      })
      .addCase('resetFromOccupancy', () => {
        return initialState;
      }),
});

export const { setCabinTypes, setSecondCabinTypes } = cabinTypesSlice.actions;
export default cabinTypesSlice.reducer;
